import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyAccount = loadable(() => import(/* webpackChunkName: "content/account" */ '.'));
